import React, { FC, useCallback } from "react";
import { Flex, SortType as UISortType } from "@evergis/ui";

import { SortByAlias } from "./SortByAlias";
import { SortByDate } from "./SortByDate";

import { useSort } from "../../hooks/useSort";

import { SortOrder, SortType } from "./types";

export const Sort: FC = () => {
  const [sort, setSort] = useSort();

  const resolveActive = useCallback((type: SortType) => !!sort[type], [sort]);

  const resolveOrder = useCallback(
    (type: SortType) => {
      return sort[type] as SortOrder;
    },
    [sort],
  );

  const handleSortKeyChange = useCallback(
    (type: SortType) => (order: SortOrder) => {
      setSort({ ...sort, [type]: order as UISortType });
    },
    [sort, setSort],
  );

  return (
    <Flex style={{ flexWrap: "nowrap", marginLeft: "0.5rem" }}>
      <SortByAlias
        active={resolveActive(SortType.Alias)}
        order={resolveOrder(SortType.Alias)}
        setSort={handleSortKeyChange(SortType.Alias)}
      />
      <SortByDate
        active={resolveActive(SortType.ChangedDate)}
        order={resolveOrder(SortType.ChangedDate)}
        setSort={handleSortKeyChange(SortType.ChangedDate)}
      />
    </Flex>
  );
};
